import React from 'react';
import { CtaButton } from './CtaButton';
import { HeroVisual } from './HeroVisual';
import { PrintCutShare } from './PrintCutShare';
import { HeartMark } from './decor/HeartMark';
export function Hero() {
  return <section id="top" aria-labelledby="hero-title" className="relative overflow-hidden bg-cream" data-id="element-140" data-mp="9lv16qmocfvu">
      <div className="mx-auto flex max-w-content flex-col items-center px-5 pb-16 pt-12 text-center sm:px-8 lg:pb-24 lg:pt-16" data-id="element-141" data-mp="4mrvd3yve5mt">
        <p className="flex items-center gap-2 text-xs font-extrabold uppercase tracking-[0.16em] text-coral-deep" data-id="element-142" data-mp="128pijeo72z53">
          <HeartMark className="h-3.5 w-3.5" data-id="element-143" data-mp="x8jmlmaw6qh7" />
          Ready-to-print Gospel outreach resources
        </p>
        <h1 id="hero-title" className="mt-5 max-w-4xl text-balance font-display text-[44px] leading-[1.02] text-navy sm:text-6xl lg:text-[76px]" data-id="element-144" data-mp="nc88cqrqrqk4">
          Share <span className="italic text-coral" data-id="element-145" data-mp="3d2bhzk51cpsw">Jesus</span> Without Wondering What to Say
        </h1>
        <p className="mt-6 max-w-2xl text-pretty text-lg leading-relaxed text-ink-soft sm:text-xl" data-id="element-146" data-mp="381nvnbrr4x50">
          Get <strong className="font-extrabold text-navy" data-id="element-147" data-mp="3j925dog4jqvj">200+ unique printable Gospel tracts</strong> and evangelism cards in{' '}
          <strong className="font-extrabold text-navy" data-id="element-148" data-mp="3o59d9ms2zcg4">20+ visual styles</strong> — ready to print, cut and share with friends, family,
          neighbors, church visitors and everyday encounters.
        </p>

        <div className="mt-10 w-full sm:mt-12" data-id="element-149" data-mp="30i18d5yke5em">
          <HeroVisual data-id="element-150" data-mp="30h9blrt8e1mr" />
        </div>

        <div className="relative z-10 mt-10 flex flex-col items-center gap-6 sm:mt-12" data-id="element-151" data-mp="30fybq32wpe0x">
          <div className="rounded-full bg-paper px-6 py-3 shadow-card ring-1 ring-cream-line" data-id="element-152" data-mp="35a2jupnwrs3l">
            <PrintCutShare data-id="element-153" data-mp="2qlofgaaufvkx" />
          </div>
          <CtaButton className="sm:min-w-[320px]" data-id="element-154" data-mp="2vieuqvetqn5a">Get Access Now</CtaButton>
          <span className="text-sm font-semibold text-ink-mute" data-id="element-155" data-mp="2vglpnkjv0aze">Instant digital access · Ready-to-print PDFs · 5 free bonuses</span>
        </div>
      </div>
    </section>;
}